let notifications = () => {

  let module = {},
    notificationIcon,
    popup,
    popupClose,
    body,
    slider,
    sliderImage,
    sliderItems,
    unreadIds,
    readIds,

    createNotificationPopup = () => {
      $('html').addClass('overflow-hidden');

      popup.show({
        complete: function() {
          $('.slick-carousel').slick('setPosition');
          popup.addClass('active');
        }
      });
    },

    onNotificationIconClick = () => {
      notificationIcon.on('click', function () {

        createNotificationPopup();
        slider.addClass('slick-play');
        playNotificationSlider();

        // We've opened the slider, add the news ids to the cookie
        let currentNewsId = slider.find('.slick-current .citem').data('news-id');
        updateUnreadNumberOnSliderAction(currentNewsId)
        // mark all as read
        // readIds = readIds.concat(unreadIds);
        // setCookie(readIds);
        // setUnreadNumber(0);
      });
    },

    onCloseButtonClick = () => {
      if (!popupClose.length) {
        return;
      }
      popupClose.on('click', function () {
        slider.find('.slick-dots>li').removeClass('slick-active');
        pauseNotificationSlider();
        $('html').removeClass('overflow-hidden');
        popup.removeClass('active');
      });

	  popup.click(function(e) {
		  if ($(this).hasClass("active")) {
			  console.log($(e.target));
			  if (
				!$(e.target).hasClass("notification-slider-wrapper") &&
				$(e.target).closest(".notification-slider-wrapper").length==0 &&
				!$(e.target).hasClass("slick-arrow")
			  ) {
				  popupClose.click();
			  }
		  }
	  });

    },

    onInitNotificationSlider = () => {
      //console.log('neki init');
      //slider.slick('slickSetOption', 'fade', false);
      //console.log(slider);
      slider.on('reInit', function(slick){
      });

    },
      onInitMagazineSlider = () => {
        $('.magazine-slider').slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                centerMode: true,
              }
            },
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ],
        });
      },


    onBeforeSlide = () => {
      slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {

      });
    },

    onAfterSlide = () => {
      slider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
        let currentNewsId = slider.find('.slick-current .citem').data('news-id');
        updateUnreadNumberOnSliderAction(currentNewsId)
      });
    },

    getActiveDotButton = () => {
      return slider.find('.slick-dots>li.slick-active>button');
    },

    onSliderImageTouch = () => {
      slider.on('touchstart mousedown', function(e){
        //e.preventDefault();
        var activeDotButton = getActiveDotButton();
        var computedWidth = activeDotButton.css('width');
        activeDotButton.css('width', computedWidth);
        pauseNotificationSlider();
      });

      slider.on('touchend mouseup mouseleave', function(e){
        //e.preventDefault();
        var activeDotButton = getActiveDotButton();
        if(!activeDotButton.attr('style')) {
          return;
        }
        activeDotButton.css({
          'width': '0px',
          'transition' : 'none',
        });
        window.setTimeout(function(){
          activeDotButton.attr('style', '');
        }, 80);

        resumeNotificationSlider();
      });
    },

    pauseNotificationSlider = () => {
      slider.slick('slickSetOption', 'autoplay', false).slick('slickPause');
    },

    resumeNotificationSlider = () => {
      slider.slick('slickSetOption', 'autoplay', true).slick('slickPlay');
    },

    playNotificationSlider = () => {
      var nr = slider.slick('slickCurrentSlide');
      slider.find('.slick-dots>li:nth-child(' + (nr + 1) + ')').addClass('slick-active');
      window.setTimeout(function(){
        resumeNotificationSlider();
      }, 800);

      //slider.slick('slickGoTo', nr);
    },

    setCookie = (value) => {
      return Cookies.set('notifications', value);
    },

    getCookie = () => {
      return Cookies.getJSON('notifications');
    },

    updateUnreadNumberOnSliderAction = (id) => {
      if (typeof readIds === 'undefined') {
        return;
      }

      if (readIds.indexOf(id) <= -1) {
        readIds.push(id);
        setCookie(readIds);

        unreadIds = unreadIds.filter(function (el) {
          return readIds.indexOf(el) < 0;
        });

        setUnreadNumber(unreadIds.length);
      }
    },

    setUnreadNumber = (number = 0) => {
      // Clear icon
      notificationIcon.find('.number').remove();
      notificationIcon.removeClass('has-notifications');

      if (number > 0) {
        notificationIcon.append("<span class='number'>" + number + "</span");
        notificationIcon.addClass('has-notifications');
      }
    },

    init = () => {
      slider = $('#notification-slider');
      if (!slider.length) {
        return;
      }
      notificationIcon = $('.notification');
      popup = $('.notification-popup');
      popupClose = popup.find('.close-button');
      sliderImage = slider.find('.citem-image-container');
      notificationIcon = $('.notification-block .notification');
      sliderItems = $('#notification-slider .citem');

      body = $('html,body');
      slider.find('.slick-dots>li').removeClass('slick-active');

      unreadIds = [];
      readIds = [];

      if (sliderItems.length > 0) {

        $.each(sliderItems, function (index, element) {
          unreadIds.push($(element).data('news-id'));
        }.bind(unreadIds));

        // get distinct ids
        unreadIds = [...new Set(unreadIds)];
        readIds = getCookie();

        if (! readIds) {
          // We don't have the cookie, set number to all and ring the bell
          setCookie([]);
          setUnreadNumber(unreadIds.length);

        } else {
          // We have the cookie…
          if (readIds.length > 0) {
            unreadIds = unreadIds.filter(function (el) {
              return readIds.indexOf(el) < 0;
            });
          }

          setUnreadNumber(unreadIds.length);

        }
      }

      onInitMagazineSlider();
      onInitNotificationSlider();
      onBeforeSlide();
      onAfterSlide();
      onNotificationIconClick();
      onCloseButtonClick();
      onSliderImageTouch();
    };

  module.init = init;

  return module;

};

export default notifications();
